// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import { useId, type InputHTMLAttributes } from 'react';

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string;
  helperText?: string;
}

export function TextField({ label, error, helperText, required, ...rest }: TextFieldProps) {
  const id = useId();
  const helpId = `${id}-help`;
  const hasError = error !== undefined && error.length > 0;
  return (
    <div className="ds-field">
      <label htmlFor={id} className="ds-field__label">
        {label}
        {required === true ? ' *' : ''}
      </label>
      <input
        id={id}
        className="ds-field__input"
        data-invalid={hasError}
        aria-invalid={hasError}
        aria-describedby={hasError || helperText !== undefined ? helpId : undefined}
        required={required}
        {...rest}
      />
      {hasError ? (
        <span id={helpId} className="ds-field__error">
          {error}
        </span>
      ) : helperText !== undefined ? (
        <span id={helpId} className="ds-field__helper">
          {helperText}
        </span>
      ) : null}
    </div>
  );
}
